var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZipFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33301 4.16675C3.33301 2.78604 4.4523 1.66675 5.83301 1.66675H10.6308C11.2938 1.66675 11.9297 1.93014 12.3986 2.39898L15.9341 5.93451C16.4029 6.40336 16.6663 7.03924 16.6663 7.70228V15.8334C16.6663 17.2141 15.5471 18.3334 14.1663 18.3334H5.83301C4.4523 18.3334 3.33301 17.2141 3.33301 15.8334V4.16675ZM14.1663 17.3334H5.83301C5.00458 17.3334 4.33301 16.6618 4.33301 15.8334V4.16675C4.33301 3.33832 5.00458 2.66675 5.83301 2.66675H10.6308C10.6706 2.66675 10.7102 2.66833 10.7496 2.67146V5.83342C10.7496 6.79991 11.5331 7.58342 12.4996 7.58342H15.6616C15.6648 7.62282 15.6663 7.66247 15.6663 7.70228V15.8334C15.6663 16.6618 14.9948 17.3334 14.1663 17.3334ZM15.1688 6.58342L11.7496 3.16421V5.83342C11.7496 6.24763 12.0854 6.58342 12.4996 6.58342H15.1688Z",
    fill: "#5B5C5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70801 1.66675V3.54175H9.58301V1.66675H7.70801ZM5.83301 3.54175V5.41675H7.70801V3.54175H5.83301ZM7.70801 5.41675V7.29175H9.58301V5.41675H7.70801ZM5.83301 7.29175V9.16675H7.70801V7.29175H5.83301ZM5.83301 9.16675V13.8542H9.58301V9.16675H5.83301ZM7.23926 10.573H8.17676V12.448H7.23926V10.573Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipFile);
export default __webpack_public_path__ + "static/media/zipFile.4625cb5fc854f366bf9d3d8a374eef1f.svg";
export { ForwardRef as ReactComponent };